import { Component, h, Host, Prop, Element } from '@stencil/core';

@Component({
    tag: 'sew-ws-image-text',
    styleUrl: 'sew-ws-image-text.scss',
    shadow: false,
})
export class SewWsImageText {
    @Element() host: HTMLSewWsImageTextElement;

    @Prop({ reflect: true, mutable: true }) noGrid = false;
    @Prop({ reflect: true, mutable: true }) noMargin = false;
    @Prop({ reflect: true }) smallMargin = false;
    @Prop({ reflect: true }) size = 'large';
    @Prop({ reflect: true }) reverse = false;
    @Prop({ reflect: true }) headline: string;
    @Prop({ reflect: true }) underlay = false;

    private isInsideTabModule = false;
    private hasCaptionEl: HTMLParagraphElement;

    private checkIfInsideSpecialModule(): void {
        if (this.host.parentElement && this.host.parentElement.nodeName === 'SEW-WS-TABS-ITEM') {
            this.isInsideTabModule = true;
            this.host.classList.add('tab-item');
            this.noGrid = true;
            this.noMargin = true;
        }

        if (this.host.parentElement && this.host.parentElement.nodeName === 'SEW-WS-TILE-GALLERY-ITEM') {
            this.host.classList.add('tile-gallery-item');
            this.noGrid = true;
            this.noMargin = true;
        }
    }

    private checkIfMoreThanOneChild(): void {
        if (!this.isInsideTabModule) return;

        const previousSibling = this.host.previousElementSibling;
        const nextSibling = this.host.nextElementSibling;

        // if there is a node add margin for small and large size
        if (previousSibling || nextSibling) {
            this.host.classList.add('has-siblings');
        }
    }

    private checkIfHasCaption = () => {
        this.hasCaptionEl = this.host.querySelector('sew-picture').shadowRoot.querySelector('.caption');

        if (this.hasCaptionEl && this.hasCaptionEl.innerText.length > 0) {
            this.host.classList.add('has-caption');
        }
    };

    componentWillLoad(): void {
        this.checkIfInsideSpecialModule();
        this.checkIfMoreThanOneChild();
    }

    componentDidLoad() {
        this.checkIfHasCaption();
    }

    render() {
        return (
            <Host class={{ 'has-headline': !!this.headline }}>
                <div class="underlay"></div>
                <div class="main-content-container">
                    {this.headline && <h2>{this.headline}</h2>}
                    <div class="slot-wrapper">
                        <slot />
                    </div>
                </div>
            </Host>
        );
    }
}
